import { render, staticRenderFns } from "./editInventoryDialog.vue?vue&type=template&id=60ba47f8&scoped=true&"
import script from "./editInventoryDialog.vue?vue&type=script&lang=ts&"
export * from "./editInventoryDialog.vue?vue&type=script&lang=ts&"
import style0 from "./editInventoryDialog.vue?vue&type=style&index=0&id=60ba47f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ba47f8",
  null
  
)

export default component.exports